<template>
  <div class="atb-flex atb-flex-row atb-gap-2">
    <span
      class="material-icons-outlined atb-align-middle"
      :title="lockTitle"
      :style="{
        color: lockIconColor,
        cursor: getLockIconCursor,
      }"
      @click="clickHandler"
    >
      {{ lockIcon }}
    </span>
    <span
      v-if="isDataSourceCoded"
      title="Filter is coded"
      class="material-icons-outlined atb-align-middle"
      >insert_drive_file</span
    >
    <span>
      <img
        v-if="!isDataSourceCoded"
        alt="Not Coded"
        title="This Filter has not been coded yet"
        src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjBweCIgaGVpZ2h0PSIyMnB4IiB2aWV3Qm94PSIwIDAgMjAgMjIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU5ICg4NjEyNykgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+ZHJhZyBoYW5kbGU8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iQXR0cmlidXRlcyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkF0dHJpYnV0ZXMtLS1BbGwtQXR0cmlidXRlcyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTc1MS4wMDAwMDAsIC00MzcuMDAwMDAwKSIgZmlsbD0iI0U0MDAyQiI+CiAgICAgICAgICAgIDxnIGlkPSJUYWJsZXMtLy0wMi0tLWRhdGEtY2VsbHMtLy0xMy0tLWRlZmF1bHQsLWRyYWcsLW1pZGRsZS1yb3dzLUNvcHktMTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDczNC4wMDAwMDAsIDQyOC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJUYWJsZXMtLy0wMi0tLWRhdGEtY2VsbHMtLy0wOS0tLWRlZmF1bHQsLWNoZWNrYm94LC1taWRkbGUtcm93cyI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9ImV4cGVyaWFuL25vdGVzX2hpZGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1LjAwMDAwMCwgNy41MDAwMDApIj4KICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTEyLjcwNyw0IEwxMi43MDcsOSBMMTcuNzA3LDkgTDE3LjcwNywxNC44NzkgTDE5LjcwNywxNi44NzkgTDE5LjcwNyw4IEwxMy43MDcsMiBMNS43MDcsMiBDNS40NDgsMiA1LjIwMSwyLjA1NCA0Ljk3MywyLjE0NSBMNi44MjgsNCBMMTIuNzA3LDQgWiBNNS43MDcsMjAgTDUuNzA3LDguNDE0IEwxNy4yOTMsMjAgTDUuNzA3LDIwIFogTTIxLjQxNCwyMS4yOTMgTDMuNDE0LDMuMjkzIEwyLDQuNzA3IEwzLjcwNyw2LjQxNCBMMy43MDcsMjAgQzMuNzA3LDIxLjEgNC41OTcsMjIgNS42OTcsMjIgTDE3LjcwNywyMiBDMTguMTUyLDIyIDE4LjU1MiwyMS44NCAxOC44ODMsMjEuNTkgTDIwLDIyLjcwNyBMMjEuNDE0LDIxLjI5MyBaIiBpZD0iZmlsbCI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"
      />
    </span>
  </div>
</template>

<script
  lang="ts"
  setup
>
  import { ICellRendererParams } from 'ag-grid-community';
  import { computed, ComputedRef, ref, Ref, toRefs } from 'vue';
  import { VersionControl } from '@/app/shared/types/version-control.interface';
  import { CursorType } from '@/app/shared/enums/cursor-type.enum';
  import { LockColor } from '@/app/shared/enums/lock-color.enum';
  import { LockIcon } from '@/app/shared/enums/lock-icon.enum';

  interface FilterDataSourceProps extends ICellRendererParams {
    dataSourceName: string;
    lockDataSource: (id: number, isAutoLock: boolean, dsName: string) => void;
    unlockDataSource: (id: number, isAutoLock: boolean, dsName: string) => void;
  }

  interface FilterDataSourceColumnProps {
    params: FilterDataSourceProps;
  }

  const props = defineProps<FilterDataSourceColumnProps>();
  const { params } = toRefs(props);
  const dataSourceVersionControl: Ref<VersionControl> = ref(
    {} as VersionControl
  );
  const filterVersionControl: Ref<VersionControl> = ref({} as VersionControl);

  const selectedDataSourceName = computed(() => params.value?.dataSourceName);

  dataSourceVersionControl.value = params.value.value?.find(
    (vc: VersionControl) => vc.dataSource?.name === selectedDataSourceName.value
  );

  filterVersionControl.value = params.value.value?.find(
    (vc: VersionControl) => vc.dataSource === null
  );

  const isDataSourceCoded: ComputedRef<boolean> = computed(
    () => dataSourceVersionControl.value?.isCoded
  );

  const isDataSourceManualLocked: ComputedRef<boolean> = computed(
    () => !!dataSourceVersionControl.value?.lockedByUserId
  );
  const isDataSourceAutoLocked: ComputedRef<boolean> = computed(
    () => !!dataSourceVersionControl.value?.autoLockedByUserId
  );
  const isDataSourceLocked: ComputedRef<boolean> = computed(
    () => isDataSourceManualLocked.value || isDataSourceAutoLocked.value
  );

  const lockIcon: ComputedRef<LockIcon> = computed(() =>
    isDataSourceLocked.value ? LockIcon.LOCK : LockIcon.LOCK_OPEN
  );

  const lockIconColor: ComputedRef<LockColor> = computed(() => {
    if (isDataSourceAutoLocked.value) {
      return LockColor.AUTO_LOCKED;
    }
    return isDataSourceManualLocked.value
      ? LockColor.LOCKED
      : LockColor.UNLOCKED;
  });

  const lockTitle: ComputedRef<string> = computed(() => {
    if (
      isDataSourceAutoLocked.value ||
      !!filterVersionControl.value?.autoLockedByUserId
    ) {
      return '';
    }
    return isDataSourceManualLocked.value
      ? `Locked by ${dataSourceVersionControl.value?.lockedByUsername}`
      : 'Click to Lock';
  });

  const getLockIconCursor: ComputedRef<CursorType> = computed(() =>
    !!filterVersionControl.value?.autoLockedByUserId ||
    isDataSourceAutoLocked.value
      ? CursorType.DEFAULT
      : CursorType.POINTER
  );

  const clickHandler = (): void => {
    const { id } = params.value?.data;
    if (
      !filterVersionControl.value?.autoLockedByUserId &&
      !isDataSourceAutoLocked.value
    ) {
      isDataSourceManualLocked.value
        ? params.value?.unlockDataSource(
            id,
            false,
            selectedDataSourceName.value
          )
        : params.value?.lockDataSource(id, false, selectedDataSourceName.value);
    }
  };
</script>
